import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UrlPath } from "utility/routes";
import CompanyAccessItem from "./UserAccess/CompanyAccessItem";
import useAccountData from "hooks/useAccountData";
import { useAuth } from "react-oidc-context";

export default function MyCompanies() {
  const [companies, setCompanies] = useState<Company[] | null>(null);
  const { getCompanies, loadingCompanies } = useAccountData();
  const auth = useAuth();

    const pushUserPaidStatusIdToGTM = (userId: string) => {


        let paidStatus = "private";
        let paidCompanies = companies?.filter(x => x.hasProducts && x.hasStats);

        if (paidCompanies !== undefined && paidCompanies?.length > 0 && paidCompanies?.length === companies?.length) {
            paidStatus = "paying_business";
        }
        else if (paidCompanies?.find(x => x.hasProducts)) {
            paidStatus = "mixed_business";
        }
        else if (companies !== undefined && companies !== null && companies?.length > 1) {
            paidStatus = "free_business";
        }

        window.dataLayer.push({
            event: "customer_update",
            customer_properties: {
                customer_type: paidStatus
            }
        });

    }

    useEffect(() => {
        if (companies !== null && companies.length > 0 && !loadingCompanies) {
            pushUserPaidStatusIdToGTM(auth.user?.profile.customer_ref as string);
        }
    }, [companies, loadingCompanies, auth.user?.profile.customer_ref as string]);


  useEffect(() => {
    async function fetchData() {
      if (!loadingCompanies) {
        const response = await getCompanies();
        if (response != null) {
          setCompanies(response);
        }
      }
    }
    fetchData();

  }, [getCompanies, loadingCompanies]);

  return (<>
    {loadingCompanies ? (<></>) : (<>
      {companies?.map((_item, _index) => (
        <CompanyAccessItem key={_index} company={_item} />
      ))}
      <p className="mt-4 mb-0">
        <Link to={UrlPath.MyAccount.AddCompany} className="btn btn-light border">
          <i className="bi bi-plus-lg"></i> Legg til annen bedrift
        </Link>
      </p>
    </>)}
  </>)
}